import * as React from 'react'
import './setup.scss'

function SetupHeader () {
  return <div className='setup-header flex-wrap'>Engagement Setup</div>
}

export default SetupHeader
